module.exports = __webpack_public_path__ + "static/cancer_annual_report2018-acbb5a3dd66b9e3d7d07759c0a86483c.pdf";